'use strict';
require('./EmailToTaskService.js');

var LIMIT = 20;
function EmailToTaskListCtrl(
  $scope,
  $stateParams,
  $translate,
  $state,
  growl,
  emails
) {
  $scope.emails = emails;
  $scope.page = $stateParams.page|0;
  if ($scope.emails.length === (LIMIT + 1)) {
    $scope.more = true;
    $scope.emails.pop();
  }
  $scope.delete = function(item) {
    item.$delete({
      companyId: $stateParams.companyId,
      emailToTaskId: item.id
    }, function() {
      $scope.emails.splice($scope.emails.indexOf(item), 1);
      growl.addSuccessMessage($translate.instant('email-to-task.delete-success'));
    }, function() {
      growl.addErrorMessage($translate.instant('email-to-task.delete-failure'));
    });
  };
}

EmailToTaskListCtrl.resolve = {
  emails: ['EmailToTaskService', '$stateParams', function(EmailToTaskService, $stateParams){
    return EmailToTaskService.query({
      companyId: $stateParams.companyId,
      limit: (LIMIT + 1),
      offset: ($stateParams.page|0) * LIMIT
    }).$promise;
  }]
};

module.exports = EmailToTaskListCtrl;

angular.module('dokiv')
  .controller('EmailToTaskListCtrl', [
    '$scope',
    '$stateParams',
    '$translate',
    '$state',
    'growl',
    'emails',
    EmailToTaskListCtrl]);


//////////////////
// WEBPACK FOOTER
// ./scripts/company/email-to-task/EmailToTaskListCtrl.js
// module id = 348
// module chunks = 0